import i18next from 'i18next'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import ja from './ja.yml'

i18next
    .use(initReactI18next)
    .use(I18nextBrowserLanguageDetector)
    .init({
        resources: {
            ja: {
                translation: ja,
            },
        },
        fallbackLng: 'ja',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            convertDetectedLanguage: (lang: string) => lang.split('-')[0],
        }
    })